namespace ekh {

    class FormState {
        private successSubmitResult: boolean = false;
        private errorSubmitResult: boolean = false;
        private formSubmitted: boolean = false;
        private formOnceClicked: boolean = false;
        private _submit: (data?: any) => ng.IPromise<any> = () => this.$q.resolve();
        private isSubmitInProcess: boolean = false;

        constructor(private form: ng.IFormController, private $q: ng.IQService) {

        }

        public setSubmitFn(submit) {
            this._submit = submit;
        }

        public isSubmitResultError(): boolean {
            return this.errorSubmitResult;
        }

        public isSubmitResultSuccess(): boolean {
            return this.successSubmitResult;
        }

        public isFormOnceClicked(): boolean {
            return this.formOnceClicked;
        }

        public submit(data): ng.IPromise<any> {
            this.formOnceClicked = true;
            if (this.form.$invalid) {
                return this.$q.reject();
            }
            this.isSubmitInProcess = true;
            return this._submit(data)
                .then((res) => {
                    this.successSubmitResult = true;
                    this.errorSubmitResult = false;
                    this.isSubmitInProcess = false;
                    return this.$q.resolve(res);
                })
                .catch((err) => {
                    this.successSubmitResult = false;
                    this.errorSubmitResult = true;
                    this.isSubmitInProcess = false;
                    return this.$q.reject(err);
                });
        }

        public resetFormState(): void {
            this.resetSubmitResult();
            this.formOnceClicked = false;
            localStorage.setItem('subscriptionState', 'subscribed'); /*setting subscriptionState in localstorage*/
        }

        public resetSubmitResult(): void {
            this.successSubmitResult = false;
            this.errorSubmitResult = false;
            this.formSubmitted = false;
            this.isSubmitInProcess = false;
        }

        public isFormValid(): boolean {
            return this.form.$valid;
        }

        public showFieldError(fieldName: string): boolean {
            if (!this.form || !this.form[fieldName]) {
                return false;
            }
            const fieldObj = this.form[fieldName];
            return fieldObj.$invalid && this.formOnceClicked && !fieldObj.focused;
        }

        public showFieldValidatorError(fieldName: string, validationError: string): boolean {
            if (!this.form || !this.form[fieldName]) {
                return false;
            }
            const formField = this.form[fieldName];
            const fieldError = formField.$error[validationError];

            return fieldError && this.formOnceClicked && !formField.focused;
        }
    }

    angular
        .module('ekh')
        .directive('formState', ($q: ng.IQService) => {
            return {
                restrict: 'A',
                link: ($scope, $element, $attrs) => {
                    $scope.formState = new FormState($scope[$attrs.name], $q);
                }
            };
        });
}
